import CustomBreadcrumb from '@website/components/CustomBreadcrumb';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { useRouter } from 'next/router';
import { Container } from 'react-bootstrap';
import RequiresAuth from '../../../../../../components/auth/RequiresAuth';
import PayBalanceForm from '../../../../../../components/checkout/PayBalanceForm';

/**
 * Pay Balance Page
 */
export default function PayPage() {
  const {
    query: { bookingId, userID },
  } = useRouter();

  if (!bookingId) return <LoadingPage />;

  return (
    <RequiresAuth>
      <Container>
        <CustomBreadcrumb
          items={[
            { text: 'Home', href: '/' },
            { text: 'Dashboard', href: `/me/${userID as string}` },
            {
              text: 'Booking',
              href: `/me/${userID as string}/bookings/${bookingId}`,
            },
            { text: 'Pay Balance', active: true },
          ]}
        />
        <h1>Pay Balance</h1>
        <PayBalanceForm bookingID={bookingId as string} />
      </Container>
    </RequiresAuth>
  );
}
